// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"126":"abafacb8","799":"9cdfb026","925":"739027f7"}[chunkId] + ".chunk.css";
};